var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67033 11.4896C6.96444 11.4896 8.11341 10.8682 8.83517 9.90751C9.55694 10.8682 10.7059 11.4896 12 11.4896C13.2941 11.4896 14.4431 10.8682 15.1648 9.90751C15.8866 10.8682 17.0356 11.4896 18.3297 11.4896C20.5145 11.4896 22.2857 9.71837 22.2857 7.53351C22.2857 6.47856 21.4946 3.19505 18.3297 1.92911C13.419 1.16994 10.6475 1.16305 5.67033 1.92911C2.5055 3.19505 1.71429 6.47856 1.71429 7.53351C1.71429 9.71837 3.48547 11.4896 5.67033 11.4896Z",
    stroke: "#000000",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 14.6429V20.2143C5.14286 22.1079 6.67788 23.6429 8.57143 23.6429H15.4286C17.3222 23.6429 18.8571 22.1079 18.8571 20.2143V14.6429",
    stroke: "#000000",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5664 19.7857H12.4235",
    stroke: "#000000",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.ef6fe6010efdbbe5b3b96765c0e4de69.svg";
export { ForwardRef as ReactComponent };